export const screenshotIsRendering =
	'https://mopinion-visual-feedback.s3-eu-west-1.amazonaws.com/camera-icon.png';

export const textInputBlocks = [
	'input',
	'textarea',
	'email',
	'phone',
	'name',
	'firstname',
	'lastname'
];

export const showNextButtonWhenAutoPost = [
	'input',
	'textarea',
	'section_break',
	'link',
	'multimedia',
	'contact',
	'checkbox'
];

//conversational related
export const typingTimeout = 800;

export const noInputBlocks = [
	'section_break',
	'multimedia',
	'text',
	'icon',
	'img',
	'link',
	'website_data',
	'ending',
	'honeybot',
	'recaptcha'
];

export const focusableBlocks = [
	'rating',
	'nps',
	'ces',
	'gcr',
	'thumbs',
	'input',
	'textarea',
	'radio',
	'checkbox',
	'link',
	'select',
	'contact',
	'category',
	'screenshot',
	'matrix',
	'likert'
];

export const multimediaBlocks = ['multimedia', 'img'];

export const alwaysNotVisibleBlocks = ['website_data'];

export const noTriggerNextBlocks = ['website_data', 'ending'];

export const requireAllBlockTypes = ['matrix', 'likert'];

export const honeyBotId = 'hb213566';
export const honeyBotTypeName = 'special_input';
